<template>
  <div>
    <header-page :namePage="$t('mc.pageTitles.informationAboutMc')" />
    <!--Смена М1-->
    <modal :isFooter="false" v-if="isModalVisible" @close="closeMCModal">
      <template v-slot:body>
        <AddMimk
          ref="modalBody"
          :isAppoint="isAppoint"
          :MasterClass="MasterClass"
          :isConfirm="true"
          @closeModal="closeMCModal"
        />
      </template>
    </modal>
    <!--Смена статуса МК-->
    <modal
      :loading="modalLoad"
      :heightOfScroll="220"
      v-if="ischangeStatusMc"
      :title="$t('mc.modals.titles.changeStatus')"
      @close="closeChangeStatusMc"
      width="400px">
      <template v-slot:body>
        <v-select
          v-model="statusModel"
          :options="adminSelectStatus"
          :clearable="false"
          @input="changeStatusMc" />
      </template>
    </modal>
    <!--  -->
    <modal
      v-if="cancelModalVisible"
      :scroll="false"
      :title="$t('mc.modals.titles.mcCancel')"
      @close="closeModals">
      <template v-slot:body>
        <span class="modal-cancel-text">
          {{ $t("mc.manager.modalCancelMk.cancel") }}
        </span>
        <ReasonSelectAndComment
          :rejectionReasons="$store.state.booking.lossReasons"
          :reasonPlaceholder="$t('mc.placeholders.selectReason')"
          @changeReason="changeReason"
          @changeComment="changeComment" />
      </template>
      <template v-slot:footer>
        <loader v-if="loadInModal" />
        <template v-else>
          <button
            class="btn btn_danger btn_autowidth btn_is-margin-right"
            :disabled="!reason"
            @click="saveMkCancel">
            {{ $t("mc.manager.modalCancelMk.buttons.cancel") }}
          </button>
          <button
            class="btn btn_danger btn_autowidth btn_transparent"
            @click="closeModals">
            {{ $t("mc.manager.modalCancelMk.buttons.closeInDetail") }}
          </button>
        </template>
      </template>
    </modal>
    <!--Подтверждение 1.0-->
    <modal
      v-if="confirmationModalVisible"
      :scroll="false"
      :title="$t('mc.modals.titles.mcFirstConfirm')"
      @close="closeModals">
      <template v-slot:body>
        <span class="modal-cancel-text">
          {{$t('mc.modals.titles.mcFirstConfirm')}}
        </span>
        <ReasonSelectAndComment
          :rejectionReasons="$store.state.booking.firstConformation"
          :reasonPlaceholder="$t('mc.placeholders.selectResult')"
          @changeReason="changeReason"
          @changeComment="changeComment" />
      </template>
      <template v-slot:footer>
        <loader v-if="loadInModal" />
        <template v-else>
          <button
            class="btn btn_blue btn_autowidth btn_is-margin-right"
            :disabled="!reason"
            @click="firstConfirmationResult">
            {{$t('mc.buttons.save')}}
          </button>
          <button
            class="btn btn_danger btn_autowidth btn_transparent"
            @click="closeModals">
            {{ $t("mc.manager.modalCancelMk.buttons.closeInDetail") }}
          </button>
        </template>
      </template>
    </modal>
    <!--Перенос МК-->
    <modal
      v-if="resheduleModalVisible"
      :title="$t('mc.modals.titles.reschedule')"
      :padding="'30px 30px 0px 30px'"
      width="1200px"
      @close="closeModals">
      <template v-slot:body>
        <select-date-mk
          type="reschedule"
          page="detail"
          :mkId="id"
          :oldDate="detail.mk_starts_at"
          :additionalInfoLoad="detail.additional_info"
          :reason="reason"
          :comment="comment"
          @close="closeModals">
          <template #reasonAndComment>
            <ReasonSelectAndComment
              :rejectionReasons="$store.state.booking.lossReasons"
              @changeReason="changeReason"
              @changeComment="changeComment" />
          </template>
        </select-date-mk>
      </template>
    </modal>
    <!--Ответы на квизы-->
    <modal
      :heightOfScroll="500"
      v-if="quizModalVisible"
      :title="'Ответы на квизы'"
      :padding="'30px 30px 0px 30px'"
      width="700px"
      @close="closeModals">
      <template v-slot:body>
        <base-table
          :head="['№', 'Вопрос', 'Ответ']"
          :columnTemplates="'20px 1fr 1fr'">
          <base-table-row
            :columnTemplates="'20px 1fr 1fr'"
            v-for="element in detail.quiz"
            :key="element.question_rank">
            <base-table-column>{{ element.question_rank }}</base-table-column>
            <base-table-column>{{ element.text_question }}</base-table-column>
            <base-table-column>{{ element.text_answer }}</base-table-column>
          </base-table-row>
        </base-table>
      </template>
    </modal>

    <loader v-if="loading" />

    <div v-else>
      <div class="detail-mk">
        <div class="detail-mk-blocks">
          <div class="detail-mk-info">
            <div class="detail-mk-info_left">
              <span class="detail-mk__title">
                {{ $t("mc.detailsMc.titles.classInfo") }}:
              </span>
              <div class="detail-mk-info_block">
                <div v-if="detail.created_at" class="detail-mk-row">
                  <span class="detail-mk-row-title">
                    {{ $t("mc.detailsMc.createdAt") }}:
                  </span>
                  <span>
                    {{
                      $dayjs(detail.created_at, "YYYY-MM-DD HH:mm").format(
                        "DD.MM.YYYY HH:mm"
                      )
                    }}
                  </span>
                </div>
                <div v-if="detail.mk_starts_at" class="detail-mk-row">
                  <span class="detail-mk-row-title">
                    {{ $t("mc.detailsMc.startMc") }}:
                  </span>
                  <span>
                    {{
                      $dayjs(detail.mk_starts_at, "YYYY-MM-DD HH:mm").format(
                        "DD.MM.YYYY HH:mm"
                      )
                    }}
                  </span>
                </div>
                <div v-if="detail.m1_name" class="detail-mk-row">
                  <span class="detail-mk-row-title">
                    {{ $t("mc.detailsMc.m1Name") }}:
                  </span>
                  <span>{{ detail.m1_name }}</span>
                </div>
              </div>
              <div
                class="detail-mk-info_block"
                v-if="
                  detail.hour_before_confirmed_at || detail.m1_confirmation_name
                ">
                <div
                  v-if="detail.hour_before_confirmed_at"
                  class="detail-mk-row">
                  <span class="detail-mk-row-title">
                    {{ $t("mc.detailsMc.confirmedTime") }}:
                  </span>
                  <span>
                    {{
                      $dayjs(detail.hour_before_confirmed_at).format(
                        "DD.MM.YYYY HH:mm"
                      )
                    }}
                  </span>
                </div>
                <div v-if="detail.m1_confirmation_name" class="detail-mk-row">
                  <span class="detail-mk-row-title">
                    {{ $t("mc.detailsMc.confirmedAt") }}:
                  </span>
                  <span style="cursor: pointer; color: var(--main-blue)" @click="role === 'admin' ? callModal({type:'changeM1', TC: detail}) : null">
                    {{ detail.m1_confirmation_name }}
                  </span>
                </div>
              </div>
              <div class="detail-mk-info_block">
                <div v-if="detail.mimk_name" class="detail-mk-row">
                  <span class="detail-mk-row-title">
                    {{ $t("mc.detailsMc.mimk") }}:
                  </span>
                  <span>
                    {{ detail.mimk_name }}
                  </span>
                </div>
                <div v-if="statusMc.status_translated" class="detail-mk-row">
                  <span class="detail-mk-row-title">
                    {{ $t("mc.detailsMc.status") }}:
                  </span>
                  <span
                    @click="openChangeMimkModal"
                    :class="[
                      'detail-mk-row-status',
                      {
                        'detail-mk-row-status_danger':
                          detail.status ===
                          $store.state.statuses.mcStatuses.cancel,
                      },
                      {
                        'detail-mk-row-status_admin': role === 'admin',
                      },
                    ]">
                    <inline-svg
                      class="table-column-status__icon"
                      :src="require(`@/assets/svg/${statusMc.svg}.svg`)" />
                    {{ statusMc.status_translated }}
                  </span>
                </div>
              </div>
              <div class="detail-mk-info_block" v-if="isClientTime">
                <div class="detail-mk-row">
                  <span class="detail-mk-row-title">
                    {{ $t("mc.detailsMc.startMcByClient") }}:
                  </span>
                  <span>
                    {{
                      `${formattedDate(detail.client_time, detail.client_tz_offset)} (UTC${viewOffset(detail.client_tz_offset)})`
                    }}
                  </span>
                </div>
                <div class="detail-mk-row">
                  <span class="detail-mk-row-title">
                    {{ $t("mc.detailsMc.clientTimezone") }}:
                  </span>
                  <span>
                    {{
                      `${detail.client_timezone_text} (UTC${viewOffset(
                        detail.client_tz_offset
                      )})`
                    }}
                  </span>
                </div>
              </div>
            </div>
            <div class="detail-mk-info_right">
              <span class="detail-mk__title">
                {{ $t("mc.detailsMc.titles.clientInfo") }}:
              </span>
              <div class="detail-mk-info_block">
                <div class="detail-mk-row">
                  <span class="detail-mk-row-title">
                    {{ $t("mc.detailsMc.segment") }}:
                  </span>
                  <span>
                    {{ cardSegment }}
                  </span>
                </div>
                <div class="detail-mk-row" v-if="tcNumber > 0">
                  <span class="detail-mk-row-title">
                    {{ $t("mc.detailsMc.tcNumber") }}:
                  </span>
                  <span>
                    {{ +tcNumber + 1 }}
                  </span>
                </div>
                <div class="detail-mk-row" v-if="detail.parent_name">
                  <span class="detail-mk-row-title">
                    {{ $t("mc.detailsMc.parent") }}:
                  </span>
                  <span>{{ detail.parent_name }}:</span>
                </div>
                <div class="detail-mk-row" v-if="detail.kid_name">
                  <span class="detail-mk-row-title">
                    {{ $t("mc.detailsMc.kid") }}:
                  </span>
                  <span>
                    {{ detail.kid_name }}
                    <span v-if="detail.kid_age">
                      , {{ `${detail.kid_age} ${$t("mc.detailsMc.years")}` }}
                    </span>
                  </span>
                </div>
              </div>
              <div class="detail-mk-info_block">
                <div class="detail-mk-row" v-if="detail.parent_email">
                  <span class="detail-mk-row-title">Email:</span>
                  <a target="_blank" :href="`mailto:${detail.parent_email}`">
                    {{ detail.parent_email }}
                  </a>
                </div>
                <div class="detail-mk-row" v-if="detail.parent_whatsapp">
                  <span class="detail-mk-row-title">
                    {{ $t("mc.detailsMc.phone") }}:
                  </span>
                  <div class="detail-mk-row-flex">
                    <a
                      target="_blank"
                      :href="`https://wa.me/${detail.parent_whatsapp}`">
                      {{ detail.parent_whatsapp }}
                    </a>
                    <div>
                      <a
                        target="_blank"
                        :href="`https://web.whatsapp.com/send?phone=${detail.parent_whatsapp}`"
                        class="detail-mk-row__icon">
                        <inline-svg
                          class="table-column-status__icon"
                          :src="require(`@/assets/svg/whatsapp.svg`)" />
                      </a>
                      <copy
                        :text="detail.parent_whatsapp"
                        :textMessage="$t('mc.toasts.copyPhone')" />
                    </div>
                  </div>
                </div>
              </div>
              <div class="detail-mk-info_block" v-if="detail.ad_campaign">
                <div class="detail-mk-row">
                  <span class="detail-mk-row-title">Ad campaign:</span>
                  <span>{{ detail.ad_campaign }}</span>
                </div>
              </div>
              <div class="detail-mk-info_block" v-if="detail.ad_offer">
                <div class="detail-mk-row">
                  <span class="detail-mk-row-title">Ad offer:</span>
                  <span>{{ detail.ad_offer }}</span>
                </div>
              </div>
              <div class="detail-mk-info_block" v-if="detail.utm_term">
                <div class="detail-mk-row">
                  <span class="detail-mk-row-title">utm_term:</span>
                  <span>{{ detail.utm_term }}</span>
                </div>
              </div>
              <div class="detail-mk-info_block flex-column">
                <div class="detail-mk-info__links">
                  <a
                    class="detail-mk-info__link"
                    v-if="detail.amocrm_id"
                    target="_blank"
                    :href="`${config.AMO_LINK}${detail.amocrm_id}`">
                    {{ $t("mc.detailsMc.links.amo") }}
                  </a>
                  <a
                    class="detail-mk-info__link"
                    v-if="detail.backoffice_id"
                    target="_blank"
                    :href="`${config.BACKOFFICE_LINK}${detail.backoffice_id}?language=${this.$store.state.user.lang.id}`">
                    {{ $t("mc.detailsMc.links.backoffice") }}
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div class="detail-mk-right">
            <label data-v-3735b6ce="" class="label">
              {{ $t("mc.detailsMc.comment") }}
              <span data-v-3735b6ce="" class="label_grey">
                ({{ $t("mc.detailsMc.notRequired") }})
              </span>
            </label>
            <textarea
              name="comment"
              v-model="additional_info"
              class="input-textarea detail-mk__comment"
              :disabled="role === 'mimk'" />
            <button
              v-if="role !== 'mimk'"
              class="btn btn_blue"
              @click="updateComment"
              :disabled="disabledButtons">
              {{ $t("mc.detailsMc.updateComment") }}
            </button>
          </div>
        </div>
        <div class="detail-mk-blocks" v-if="id && segmentId">
          <Tags style="margin-top: 15px;margin-bottom: 15px;" :prop-segment-id="segmentId" entity-type="booking" :entity-id="id"></Tags>
        </div>
        <div v-if="zoom_start_url || zoom_join_url || canUseZoomFlags">
          <h2 class="mb-10">Zoom:</h2>
          <div class="zoom-links-wrapper">
            <a
                v-if="zoom_start_url && !isZoomButtonActive()"
                href="javascript:void(0)"
                class="zoom-start-link zoom-start-link--disabled"
                v-tooltip="zoomStartUrlTooltip()"
            >
              <inline-svg :height="54" :src="require(`@/assets/svg/zoom-play.svg`)"></inline-svg>
            </a>
            <a
                v-else-if="zoom_start_url"
                :href="zoom_start_url"
                class="zoom-start-link"
                target="_blank"
                v-tooltip="zoomStartUrlTooltip()"
            >
              <inline-svg :height="54" :src="require(`@/assets/svg/zoom-play.svg`)"></inline-svg>
            </a>
            <a
                v-if="zoom_join_url"
                href="javascript:void(0)"
                @click="copyToClipboard(zoom_join_url)"
                class="zoom-join-link"
                v-tooltip="$t('mc.zoom.copyZoom')"
            >
                  <span>
                    <inline-svg :height="16" :src="require(`@/assets/svg/upload-icon-white.svg`)"></inline-svg>
                  </span>
            </a>
            <div v-if="canUseZoomFlags">
              <span
                v-if="zoom_link_in_wa_sent && zoom_link_in_wa_sent === true"
                class="zoom-join-link"
                v-tooltip="$t('mc.zoom.zoomLinkWaTrue')"
              >
                <img width="40px" height="40px" :src="require(`@/assets/svg/whatsapp_actiive.svg`)" />
              </span>
              <span
                v-else
                class="zoom-join-link"
                v-tooltip="$t('mc.zoom.zoomLinkWaFalse')"
              >
                <img width="40px" height="40px" :src="require(`@/assets/svg/whatsapp_not_active.svg`)" />
              </span>
              <span
                v-if="zoom_link_in_mail_sent && zoom_link_in_mail_sent === true"
                class="zoom-join-link"
                v-tooltip="$t('mc.zoom.zoomLinkMailTrue')"
              >

                <img width="40px" height="40px" :src="require(`@/assets/svg/mail_active.svg`)" />

              </span>
              <span
                v-else
                class="zoom-join-link"
                v-tooltip="$t('mc.zoom.zoomLinkMailFalse')"
              >

                <img width="40px" height="40px" :src="require(`@/assets/svg/mail_not_active.svg`)" />

              </span>
            </div>
          </div>
          <div class="zoom-info">
            <div class="zoom-info-row" @click="copyToClipboard(zoom_meeting_id)">
              <span class="detail-mk-row-title">{{$t('mc.zoom.id')}}</span>
              <span>{{zoom_meeting_id}}</span>
            </div>
            <div class="zoom-info-row" @click="copyToClipboard(1)">
              <span class="detail-mk-row-title">{{$t('mc.zoom.password')}}</span>
              <span>1</span>
            </div>
          </div>
        </div>
        <div
          class="detail-mk-buttons"
          v-if="showButtons && (role === 'manager' || role === 'admin')">
          <button
            class="btn btn_success btn_autowidth btn_is-margin-right"
            v-if="!detail.hour_before_confirmed"
            @click="confirmBeforeHour">
            {{ $t("mc.detailsMc.buttons.confirmBeforeHour") }}
          </button>
          <button
            class="btn btn_blue btn_autowidth btn_is-margin-right"
            @click="openModalReshedule">
            {{ $t("mc.detailsMc.buttons.rescheduleMc") }}
          </button>
          <button
            class="btn btn_danger btn_autowidth btn_is-margin-right"
            @click="openModalCancel"
            :disabled="disabledButtons">
            {{ $t("mc.detailsMc.buttons.cancelMc") }}
          </button>
          <button v-if="canUseFirstConfirmation"
            class="btn btn_blue btn_autowidth btn_is-margin-right"
            @click="openModalConfirmation"
            :disabled="disabledButtons">
            {{$t('mc.modals.titles.mcFirstConfirm')}}
          </button>
          <button
            class="btn btn_autowidth btn_white"
            @click="openModalQuiz"
            v-if="quiz">
            {{ $t("mc.detailsMc.modalTitleQuez") }}
          </button>
        </div>
        <div class="detail-mk-buttons">
          <button
            v-if="showReturnMcButton"
            class="btn btn_blue btn_autowidth"
            @click="revertMk">
            {{ $t("mc.detailsMc.buttons.returnMc") }}
          </button>
        </div>
        <div class="payment-table" v-if="clientOrders.length">
          <h2 class="payment-table__title">
            {{ $t("mc.detailsMc.paymentDetail.title") }}
          </h2>
          <base-table
            :itemsCenter="true"
            :headHeightStatic="90"
            :head="tableData.head"
            :columnTemplates="tableData.sizeColumn">
            <base-table-row
              v-for="element of clientOrders"
              :key="element.id"
              :columnTemplates="tableData.sizeColumn">
              <base-table-column class="cell-content">
                {{ element.order }}
              </base-table-column>
              <base-table-column class="cell-content">
                {{ element.amount }}
              </base-table-column>
              <base-table-column class="cell-content">
                {{ element.currency }}
              </base-table-column>
              <base-table-column class="cell-content">
                {{ paymentStatus(element.is_payed) }}
              </base-table-column>
              <base-table-column class="cell-content">
                {{ element.payed_datetime }}
              </base-table-column>
            </base-table-row>
          </base-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import config from "@/config";
import segmentIdToNameSegment from "@/helpers/segmentIdToNameSegment";
import cookie from "js-cookie";
import apiBooking from "@/api/master-classes/booking";
import SelectDateMk from "@/components/MK/SelectDateMk.vue";
import ReasonSelectAndComment from "@/components/ReasonSelectAndComment.vue";
import Copy from "@/components/UI/Copy";
import choiseSelectTitleOnLoad from "@/helpers/selects";
import Tags from "@/components/Supervisor/Tags"
import copyToClipboard from "@/helpers/copyToClipboard";
import { isDateTimeInRange } from "@/helpers/commonHelpers";
import { BACKOFFICE } from '@/services/HTTPService'
import AddMimk from '@/components/Manager/AddMimk.vue'
export default {
  components: {
    AddMimk,
    SelectDateMk,
    ReasonSelectAndComment,
    Copy,
    Tags,
  },
  data() {
    return {
      choiseSelectTitleOnLoad,
      segmentIdToNameSegment,
      isClientTime: false,
      modalLoad: false,
      canUseFirstConfirmation: false,
      canUseZoomFlags: false,
      ischangeStatusMc: false,
      clientOrders: [],
      tableData: {
        head: [
          this.$t("mc.detailsMc.paymentDetail.table.titles.accountNumber"),
          this.$t("mc.detailsMc.paymentDetail.table.titles.amount"),
          this.$t("mc.detailsMc.paymentDetail.table.titles.currency"),
          this.$t("mc.detailsMc.paymentDetail.table.titles.paymentStatus"),
          this.$t("mc.detailsMc.paymentDetail.table.titles.dateOfPayment"),
        ],
        sizeColumn: "repeat(5, 1fr)",
      },
      adminSelectStatus: [
        this.$t("mcStatuses.booked"),
        this.$t("mcStatuses.inWork"),
        this.$t("mcStatuses.success"),
        this.$t("mcStatuses.cancel"),
      ],
      role: "",
      loading: true,
      showButtons: true,
      config,
      id: "",
      detail: "",
      statusMc: {
        svg: "",
        name: "",
        canceled: "",
      },
      additional_info: "",
      reason: "",
      comment: "",
      statusModel: "",
      cardSegment: "",
      disabledButtons: false,
      loadInModal: false,
      cancelModalVisible: false,
      confirmationModalVisible: false,
      resheduleModalVisible: false,
      quizModalVisible: false,
      tcNumber: 0,
      quiz: [],
      segmentId: null,
      zoom_start_url: null,
      zoom_meeting_id: null,
      zoom_link_in_mail_sent: null,
      zoom_link_in_wa_sent: null,
      zoom_join_url: null,
      zoom_session_starts_at: null,
      zoom_session_ends_at: null,
      isModalVisible: false,
      isAppoint: true,
      MasterClass: null,
    };
  },
  computed: {
    showReturnMcButton() {
      return (
        this.statusMc.status_translated ===
          this.$store.state.statuses.mcStatusesWithTranslate[this.lang]
            .cancel && this.role !== "mimk"
      );
    },
    lang() {
      return this.$store.state.user.lang.id;
    },
  },
  async created() {
    this.role = cookie.get("role");
    this.id = this.$route.params.id;

    await this.getBooking();
    this.statusModel = this.statusMc.name;
    const orders = await apiBooking.getCkientOrders(this.detail.backoffice_id);
    const replaceEmptyFieldDash = "__".toUpperCase();
    this.clientOrders = orders.filter((el) => {
      for (const property in el) {
        const isvalueCame = !!el[property];
        if (!isvalueCame) el[property] = replaceEmptyFieldDash;
      }
      if (el.payed_datetime !== replaceEmptyFieldDash.toUpperCase()) {
        el.payed_datetime = this.$dayjs(el.payed_datetime).format(
          "DD.MM.YYYY HH:mm"
        );
      }
      return el.first_payment_after_mk;
    });
  },
  async mounted() {
    this.canUseFirstConfirmation = await this.getSegmentForFirstConfirmation();
    this.canUseZoomFlags = await this.getSegmentForZoomFlags()
  },
  methods: {
    isZoomButtonActive() {
      return isDateTimeInRange(null, this.detail.zoom_session_starts_at, this.detail.zoom_session_ends_at, this.$store.state.user.segment.tz_offset) &&
          (this.$store.state.user.user.id === this.detail.mimk || this.$store.state.user.user.role === 'supervisor' || this.$store.state.user.user.role === 'admin')
    },
    zoomStartUrlTooltip() {
      const isZoomButtonActive = this.isZoomButtonActive()

      if (isZoomButtonActive) return this.$t('mc.zoom.startZoom')

      const now = this.$dayjs(this.$dayjs(new Date()).utc().add(this.$store.state.user.segment.tz_offset, 'second').format('YYYY-MM-DD HH:mm'))
      const startDate = this.$dayjs(this.detail.zoom_session_starts_at)

      if (now.isBefore(startDate)) return this.$t('mc.zoom.prompt2', [startDate.format('HH:mm')])

      if (this.detail.mimk !== this.$store.state.user.user.id && this.$store.state.user.user.role !== 'supervisor' && this.$store.state.user.user.role !== 'admin') {
        return this.$t('mc.zoom.prompt1')
      }

      return this.$t('mc.zoom.prompt3')
    },
    formattedDate(date, tzSeconds) {
      return this.$dayjs(date).add(tzSeconds, 'second').format(
          "DD.MM.YYYY HH:mm"
      )
    },
    copyToClipboard(text) {
      copyToClipboard(text, () => {
        this.$toasted.global.all_ok(this.$t('mc.toasts.copyLink'))
      })
    },
    viewOffset(currentOffset) {
      const offset = currentOffset / 60 / 60;
      return currentOffset > 0 ? `+${offset}` : offset;
    },
    openChangeMimkModal() {
      if (this.role === "admin") {
        this.ischangeStatusMc = true;
      }
    },
    closeChangeStatusMc() {
      this.ischangeStatusMc = false;
    },
    paymentStatus(bool) {
      return `${bool}` === 'true' ? this.$t("mc.detailsMc.paymentDetail.table.paid") : this.$t("mc.detailsMc.paymentDetail.table.noPaid");
    },
    async changeStatusMc(status) {
      const translatedStatuses =
        this.$store.state.statuses.mcStatusesWithTranslate;
      const choisenLanguageStatuses =
        translatedStatuses[this.$store.state.user.lang.id];
      let statusForServer = "";
      for (let el in choisenLanguageStatuses) {
        if (choisenLanguageStatuses[el] === status) {
          statusForServer = translatedStatuses.ru[el];
        }
      }
      this.modalLoad = true;
      const respAfterChangeStatus = await apiBooking.addSuccessMkinfo(
        this.id,
        statusForServer,
        undefined,
        false
      );
      if (respAfterChangeStatus) this.ischangeStatusMc = false;
      this.modalLoad = false;
      await this.getBooking();
    },
    async getBooking() {
      this.loading = true;
      const detail = await apiBooking.getBooking(this.id);
      const {
        autobooking,
        client_time,
        client_tz_offset,
        client_timezone_text,
      } = detail;
      if (
        !!autobooking &&
        !!client_time &&
        !!client_tz_offset &&
        !!client_timezone_text
      )
        this.isClientTime = true;
      this.detail = detail;
      let svgName = "status-wait";
      if (detail.status === this.$store.state.statuses.mcStatuses.cancel)
        svgName = "status-cancel";
      if (detail.status === this.$store.state.statuses.mcStatuses.success)
        svgName = "status-complete";
      if (
        detail.status === this.$store.state.statuses.mcStatuses.cancel ||
        detail.status === this.$store.state.statuses.mcStatuses.success
      ) {
        this.showButtons = false;
      } else {
        this.showButtons = true;
      }

      this.statusMc.svg = svgName;
      this.statusMc.name = detail.status_translated;
      this.statusMc.status_translated = detail.status_translated;
      this.statusMc.canceled = detail.status === "Отменен";
      this.cardSegment = this.segmentIdToNameSegment(detail.segment);
      this.segmentId = detail.segment;
      this.tcNumber = detail.tc_number;
      this.additional_info = detail.additional_info;
      this.quiz = detail.quiz;
      this.zoom_start_url = detail.zoom_start_url;
      this.zoom_meeting_id = detail.zoom_meeting_id;
      this.zoom_join_url = detail.zoom_join_url;
      this.zoom_link_in_mail_sent = detail.zoom_link_in_mail_sent;
      this.zoom_link_in_wa_sent = detail.zoom_link_in_wa_sent;
      this.zoom_session_starts_at = detail.zoom_session_starts_at;
      this.zoom_session_ends_at = detail.zoom_session_ends_at;

      this.loading = false;
    },
    async updateComment() {
      this.disabledButtons = true;
      const update = await apiBooking.updateBooking(this.id, {
        additional_info: this.additional_info,
      });
      if (update === "ok") {
        this.$toasted.global.all_ok(this.$t("mc.toasts.updateComment"));
      }
      await this.getBooking();
      this.disabledButtons = false;
    },
    async revertMk() {
      const revert = await apiBooking.updateBooking(this.$route.params.id, {
        status: "Записан",
        is_deleted: false,
      });
      if (revert === "ok") {
        this.$toasted.global.all_ok(this.$t("mc.toasts.mcReturned"));
        await this.getBooking();
      }
    },
    openModalCancel() {
      this.cancelModalVisible = true;
    },

    openModalConfirmation() {
      this.confirmationModalVisible = true;
    },
    openModalQuiz() {
      this.quizModalVisible = true;
    },
    openModalReshedule() {
      this.resheduleModalVisible = true;
    },
    async closeModals(value) {
      this.cancelModalVisible = false;
      this.resheduleModalVisible = false;
      this.confirmationModalVisible = false;
      this.quizModalVisible = false;
      this.loadInModal = false;
      this.reason = "";
      if (value) {
        if (value.type === "reschedule") {
          this.$router.replace(`/master-classes/detail/${value.id}`);
        }
      }
    },
    changeReason(reason) {
      this.reason = reason.actual;
    },
    changeComment(comment) {
      this.comment = comment;
    },
    async saveMkCancel() {
      this.loadInModal = true;
      const isCommentExist = !!this.comment;
      const transmittedQueryParams = isCommentExist
        ? `loss_reason=${this.reason}&comment=${this.comment}`
        : `loss_reason=${this.reason}`;
      await apiBooking
        .removeBooking(this.id, transmittedQueryParams)
        .then(async () => {
          this.closeModals();
          this.$toasted.global.all_ok(this.$t("mc.toasts.mcCanceled"));
          await this.getBooking();
        })
        .catch(() => {
          this.loadInModal = false;
        });
    },

    async firstConfirmationResult() {
      this.loadInModal = true;

      try {
        const successfulConfirmation = ["Успешное подтверждение", "Не дозвонились до клиента"];
        if (successfulConfirmation.includes(this.reason)) {
          await apiBooking.updateFirstConfirmation(this.id, {
            first_confirmation_result: this.reason,
            first_confirmation_by: this.$store.state.user.user.id,
            first_confirmation_by_name: this.$store.state.user.user.full_name,
            first_confirmation_comment: this.comment,
          });
          await this.getBooking();
        } else {
          await apiBooking.updateFirstConfirmation(this.id, {
            first_confirmation_result: this.reason,
            first_confirmation_by: this.$store.state.user.user.id,
            first_confirmation_by_name: this.$store.state.user.user.full_name,
            first_confirmation_comment: this.comment,
          });
          await this.saveMkCancel();
        }
        this.closeModals();
        this.$toasted.global.all_ok(this.$t("mc.firstConfirm.success"));
        await this.getBooking();
      } catch (error) {
        console.error(error);
        this.$toasted.global.error(this.$t("mc.firstConfirm.error"));
      } finally {
        this.loadInModal = false;
      }
    },


    async getSegmentForFirstConfirmation() {
      try {
        const response = await BACKOFFICE.get(`/segments/${this.$store.state.user.segment.id}/`);
        return response.data.use_first_confirmation;
      } catch (e) {
        console.error(e);
        return false;
      }
    },

    async getSegmentForZoomFlags() {
      try {
        const response = await BACKOFFICE.get(`/segments/${this.$store.state.user.segment.id}/`);
        return response.data.use_sending_zoom_links;
      } catch (e) {
        console.error(e);
        return false;
      }
    },


    async confirmBeforeHour() {
      this.disabledButtons = true;
      const confirm = await apiBooking.updateBooking(this.id, {
        hour_before_confirmed: true,
      });
      if (confirm) {
        this.detail.hour_before_confirmed = true;
        this.$toasted.global.all_ok(this.$t("mc.toasts.mcConfirmed"));
        await this.getBooking();
      }
      this.disabledButtons = false;
    },
    callModal({ type, TC }) {
      this.isModalVisible = true;
      this.MasterClass = TC;
      type === "changeM1"
        ? (this.isAppoint = false)
        : (this.isAppoint = true);
    },

    async closeMCModal(isRerender) {
      //При закрытии модалки убираем активный класс с выбранного мимка
      this.$refs.modalBody.removeCheckM1();
      this.isModalVisible = false;
      //Если закртие произошло после назначения МК, то делаем запрос на получения МК и перерендериваем страницу
      if (isRerender) {
        this.isLoad = true;
        await this.getBooking();
        this.isLoad = false;
      }
    },
  },
  watch: {
    $route(to) {
      this.id = to.params.id;
      this.getBooking();
    },
  },
};
</script>

<style lang="scss" scoped>
.reason-select {
  margin-bottom: 30px;
}
.payment-table {
  &__title {
    margin-bottom: 10px;
  }
}
.detail-mk {
  padding: 32px 24px;
  background: #fff;
  &-blocks {
    display: grid;
    grid-template-columns: 2fr 1fr;
    column-gap: 32px;
  }
  &-info {
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: 32px;
    &_block {
      margin: 20px 0;
    }
    &__links {
      margin: 0 auto;
    }
    &__link {
      display: block;
      margin-bottom: 5px;
    }
  }
  &__title {
    font-weight: 600;
    font-size: 16px;
    display: flex;
    align-items: center;
  }
  &-row {
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: 8px;
    padding: 3px 0;
    &-flex {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    &-title {
      margin-right: 10px;
      font-weight: 500;
      display: flex;
      align-items: center;
    }
    &-status {
      display: flex;
      align-items: center;
      &__icon {
        margin-right: 8px;
      }
      &_danger {
        color: var(--danger);
      }
      &_admin {
        cursor: pointer;
        color: var(--main-blue);
      }
    }
  }
  &-right {
    margin-top: 10px;
  }
  &__comment {
    margin-bottom: 13px;
  }
  &-buttons {
    margin-top: 40px;
    display: flex;
    & > div {
      display: flex;
    }
  }
}

.zoom-info-row {
  display: flex;
  width: 25%;
  justify-content: space-between;
  margin-bottom: 10px;
}
</style>
